export default "__VITE_ASSET__Ch13OgON__";